import { defineComponent as _defineComponent } from 'vue'
import { inject } from 'vue'
import { ModalInjectionKey } from './injection-key'


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalContent',
  setup(__props) {

const { contentMaxHeight: maxHeight, contentMinHeight: minHeight } = inject(ModalInjectionKey)!

return { __sfc: true,maxHeight, minHeight }
}

})